import { useState } from "react";

/**
 * Drop-in replacement for <input type="password"> with show/hide eye toggle.
 * Accepts the same props as a normal input (value, onChange, placeholder, style, className, etc.)
 */
const PasswordInput = ({ style, className, wrapperStyle, ...props }) => {
  const [show, setShow] = useState(false);

  return (
    <div style={{ position: "relative", width: "100%", ...wrapperStyle }}>
      <input
        {...props}
        type={show ? "text" : "password"}
        className={className}
        style={{
          width: "100%",
          paddingRight: 40,
          boxSizing: "border-box",
          ...style,
        }}
      />
      <button
        type="button"
        onClick={() => setShow(v => !v)}
        style={{
          position: "absolute",
          right: 10,
          top: "50%",
          transform: "translateY(-50%)",
          background: "none",
          border: "none",
          cursor: "pointer",
          padding: 4,
          color: "#9ca3af",
          fontSize: 16,
          lineHeight: 1,
          display: "flex",
          alignItems: "center",
        }}
        tabIndex={-1}
        aria-label={show ? "Hide password" : "Show password"}
      >
        {show ? "🙈" : "👁️"}
      </button>
    </div>
  );
};

export default PasswordInput;
